import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Card, CardBody,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Tooltip
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import moment from 'moment';
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { range, size } from "lodash";

import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';

import Task from '../Common/Task';

const PpmCalendar = props => {

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'weekly', value: 'weekly' });
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));
  const [showDropdown, setShowDropdown] = useState(false);

  const [data, setData] = React.useState([]);
  const [assets, setAssets] = React.useState([]);
  const [spans, setSpans] = React.useState(['ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4', 'ppmcols-4']);

  const [currYear, setCurrYear] = React.useState(moment().format('YYYY'));
  const [query, setQuery] = React.useState('');

  const [errors, setErrors] = React.useState([]);

  const [initializing, setInitializing] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [taskId, setTaskId] = React.useState(null);

  const dateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
  ];

  // const bgColors = [
  //   'rgb(226, 138, 138)',
  //   '#ededfb',
  //   'rgb(222, 235, 228)',
  //   'rgb(246, 229, 247)',
  //   'rgb(218, 239, 254)',
  //   'rgb(246, 230, 217)',
  //   'rgb(214, 246, 243)',
  //   'rgb(243, 246, 220)',
  //   'rgb(242, 222, 206)',
  //   'rgb(213, 206, 245)',
  //   'rgb(203, 236, 199)',
  //   'rgb(244, 217, 227)',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  //   '#ededfb',
  // ];


  const bgColors = [
    '#DE7B81',
    '#8787EB',
    '#8CBE74',
    '#AA70B4',
    '#A49180',
    '#6D95D1',
    '#4FAA9A',
    '#D1AE69',
    '#ABB66B',
    '#B87C80',
    '#868686',
    '#9ED684',
  ];
  const bg2Colors = [
    '#DE7B8110',
    '#8787EB10',
    '#8CBE7410',
    '#AA70B410',
    '#A4918010',
    '#6D95D110',
    '#4FAA9A10',
    '#D1AE6910',
    '#ABB66B10',
    '#B87C8010',
    '#86868610',
    '#9ED68410',
  ];

  const colorClasses = {
    'completed': 'calIcn calendar-completed',
    'pending': 'calIcn calendar-pending',
    'missed': 'calIcn calendar-missed',
    'delayed': 'calIcn calendar-delayed',
    'cancelled': 'calIcn calendar-cancelled',
  };

  const columns = [{
    dataField: 'slno',
    text: '#',
    sort: true,
  },
  {
    dataField: 'asset.name',
    text: 'Asset name',
    // formatter: () => '-',
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: 'previous',
    text: 'Previous Status',
    // formatter: () => '-',
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: 'current',
    text: 'Current Status',
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: 'daily_tasks',
    text: 'Daily tasks affected',
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: 'ppm_tasks',
    text: 'PPM Tasks affected',
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: 'created_at',
    text: 'Date & time',
    sort: true,
    filter: textFilter(),
    formatter: (cell, row, rowIndex) => (moment(cell).format('DD MMM YYYY hh:mm a') || '-'),
    filterValue: (cell, row, rowIndex) => (moment(cell).format('DD MMM YYYY hh:mm a') || '-'),
    csvFormatter: (cell, row, rowIndex) => (moment(cell).format('DD MMM YYYY hh:mm a') || '-'),
  },
  {
    dataField: 'user.name',
    text: 'Done by',
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: 'remarks',
    text: 'Remark',
    sort: true,
    filter: textFilter(),
  },
  ];

  const handleSubmit = () => {

    if (moment(endDate) < moment(startDate)) {
      cogoToast.error('End date cannot be before Start date');
      return;
    }

    let data = {
      'start_date': startDate,
      'end_date': endDate,
      // property_id: props.filterProperty.id,
      'block_id': props.filterBlock.id,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_ASSETSTATUSLOG, data)
      .then((response) => {
        console.log('RESP', response.data);
        if (response.status == 200) {
          setData(response.data)
        }
        else if (response.status == 400) {
          setErrors(Object.values(response.error));
        }
        else {
          console.log('err::', response);
        }
      }, (error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const initCal = async () => {
    let temp = [];
    let start = moment().startOf('year').startOf('week').add(1, 'day');
    let end = moment().endOf('year').endOf('week').add(1, 'day');
    let i = 0;
    let sizes = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    while (start < end) {
      let nm = false;
      let tm = 0;

      if (temp.length > 0) {
        let tDate = moment(start).add(6, 'days');
        if (start.month() == tDate.month()) {
          // no change in between week
          if (start.month() > temp[temp.length - 1].month) {
            // console.log('Month started on 1st, Monday', start.month());
            nm = true;
          }
          tm = start.month();
        }
        else {
          // mid-week change : Consider tDate's month as baseline, except in Dec
          if (start.month() == 11) {
            tm = start.month();
          }
          else {
            nm = true;
            tm = tDate.month();
          }
        }
      }

      sizes[tm]++;

      temp.push({
        'id': null,
        'week': i + 1,
        'month': tm,
        'start': start.format('DD'),
        'newMonth': nm,
        'end': start.add(6, 'days').format('DD'),
        'total': 0,
        'ppmactivity': null,
        'asset': null,
        'location': '',
      });
      start.add(1, 'day');
      i++;
    }
    setData(temp);
    let tempSpans = sizes.map(s => 'ppmcols-' + s);
    setSpans(tempSpans);
  };


  const fetchData = async (year) => {
    // if(data.length < 1) {
    //   return;
    // };
    if (!props.filterBlock) { return; }
    setLoading(true);
    post(url.GET_PPM_CALENDAR,
      {
        block_id: props.filterBlock.id,
        year: year,
      }).then(response => {
        console.log('RESP', response.data);
        if (response.status == 200) {
          // setEvents(response.data.events);

          // let tempTasks = JSON.parse(JSON.stringify(data));
          // response.data.tasks.map((tItem, iIdx)=>{
          //   // console.log(tItem.week, data);
          //   let tRes = tempTasks.findIndex(d => d.week == tItem.week);
          //   if(tRes !== -1) {
          //     tempTasks[tRes].total++;
          //   }
          // });
          // setData(tempTasks);

          // let tempAssets = response.data.tasks;

          // let leng = moment({year: currYear}).weeksInYear();
          // let a = new Array(leng); for (let i=0; i<leng; ++i) a[i] = 0;

          // tempAssets.map((tAss, tIdx) => {
          //   tempAssets[tIdx].calendar = a;
          // });

          // tempAssets.map((tAss, tIdx) => {
          //   let tempData = JSON.parse(JSON.stringify(tAss.calendar));
          //   tempData[moment(tempAssets.start_date).week()]++;
          //   tempAssets[tIdx].calendar = tempData;
          // });

          // setAssets(tempAssets);

          setAssets(response.data.assets);
          setData(response.data.data);
          setSpans(response.data.sizes);

          setLoading(false);
          setCurrYear(year);


          // let tempSpans = sizes.map(s => 'ppmcols-'+s);

        }
        else {
          // setData(null);
          setLoading(false);
        }
      })
      .catch(error => {
        console.log('err:', error);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (props.filterBlock) {
      setQuery('');
      fetchData(moment().year());
    }
  }, [props.filterBlock]);




  const displayedAssets = query == '' ? assets :
    assets.filter(a => a.name.toLowerCase().includes(query.toLowerCase()) ||
      a.code.toLowerCase().includes(query.toLowerCase()) ||
      a.location.toLowerCase().includes(query.toLowerCase())
    );

  return (
    <ScrollSync>
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>PPM Calendar | Digital Logbook</title>
          </MetaTags>
          <Container fluid>
            <div className="mb-0 d-flex flex-row justify-content-between align-items-center">
              <h3 className="mb-0">PPM Calendar</h3>

              <Link className="btn btn-primary" to="/activities/index">Export</Link>

            </div>




            <Card className="mb-5 bg-transparent">
              <CardBody>
                {/* <div className="calInner2">
                    <div className="border-bottom border-white th-ppm mb-2">&nbsp;</div>
                    <div className="border-bottom border-white th-ppm">Week #</div>
                    <div className="border-bottom border-white th-ppm">Start <span style={{color: '#0004'}}>/ Mon</span></div>
                    <div className="border-bottom border-white th-ppm">End <span style={{color: '#0004'}}>/ Sun</span></div>
                    <div className="border-bottom border-white th-ppm">Total</div>
                  </div> */}

                <div className=" d-flex flex-column align-items-stretch position-relative"
                  style={{
                    height: '69vh',
                    whiteSpace: 'nowrap',
                  }}>
                  {/* <div className="border border-danger"> */}
                  <div className="d-flex flex-row justify-content-start align-items-stretch position-relative"
                  // style={{width: 'auto'}}
                  >
                    <div className="calInner">
                      <div className="fs-4" style={{ lineHeight: '1.1rem' }}>
                        Year
                        </div>
                      <Dropdown
                        isOpen={showDropdown}
                        toggle={() => { setShowDropdown(!showDropdown); }}
                      >
                        <DropdownToggle
                          tag="button"
                          className="btn fs-5 ps-0"
                        >
                          {currYear} <i className="mdi mdi-chevron-down"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => { fetchData(2021); }} className="">2021</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2022); }} className="">2022</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2023); }} className="">2023</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2024); }} className="">2024</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2025); }} className="">2025</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2026); }} className="">2026</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2027); }} className="">2027</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2028); }} className="">2028</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2029); }} className="">2029</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2030); }} className="">2030</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                    <div className="calLeft" style={{ width: 360 }}>
                      {/* <div className="mb-4 d-flex flex-column align-items-stretch justify-content-start"> */}
                      {/* </div> */}

                      <div className="th-ppm mb-2">&nbsp;</div>
                      <div className="th-ppm">Week #</div>
                      <div className="th-ppm">Start <span style={{ color: '#0004' }}>/ Mon</span></div>
                      <div className="th-ppm">End <span style={{ color: '#0004' }}>/ Sun</span></div>
                      <div className="th-ppm">Total</div>
                    </div>

                    <ScrollSyncPane>
                      <div className="flex-1 d-flex flex-column justify-content-start align-items-stretch overflow-auto">
                        <div className="mb-0 d-flex flex-row fw-medium" style={{ height: 50, }}>
                          <div className={spans[0]}>
                            Jan 2022
                            </div>
                          <div className={spans[1]}>
                            Feb 2022
                            </div>
                          <div className={spans[2]}>
                            Mar 2022
                            </div>
                          <div className={spans[3]}>
                            Apr 2022
                            </div>
                          <div className={spans[4]}>
                            May 2022
                            </div>
                          <div className={spans[5]}>
                            Jun 2022
                            </div>
                          <div className={spans[6]}>
                            Jul 2022
                            </div>
                          <div className={spans[7]}>
                            Aug 2022
                            </div>
                          <div className={spans[8]}>
                            Sep 2022
                            </div>
                          <div className={spans[9]}>
                            Oct 2022
                            </div>
                          <div className={spans[10]}>
                            Nov 2022
                            </div>
                          <div className={spans[11]}>
                            Dec 2022
                            </div>
                        </div>
                        <div className=""
                          style={{ fontSize: '.85rem' }}
                        >
                          <div className="d-flex flex-row fw-medium" style={{ color: '#fff' }}>
                            {data.map((item, itemIdx) => (
                              <div key={itemIdx} className="td-ppm"
                                style={{ marginRight: '0rem', marginLeft: item.newMonth ? '1rem' : '0rem', backgroundColor: bgColors[item.month] }}>
                                {item.week}
                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-row" style={{ color: '#fffa' }}>
                            {data.map((item, itemIdx) => (
                              <div key={itemIdx} className="td-ppm"
                                style={{ marginRight: '0rem', marginLeft: item.newMonth ? '1rem' : '0rem', backgroundColor: bgColors[item.month] }}>
                                {item.start}
                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-row" style={{ color: '#fffa' }}>
                            {data.map((item, itemIdx) => (
                              <div key={itemIdx} className="td-ppm"
                                style={{ marginRight: '0rem', marginLeft: item.newMonth ? '1rem' : '0rem', backgroundColor: bgColors[item.month] }}>
                                {item.end}
                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-row">
                            {data.map((item, itemIdx) => (
                              <div
                                //onClick={() => { setTaskId(291); }}
                                key={itemIdx} className="td-ppm fw-medium"
                                style={{
                                  marginRight: '0rem', marginLeft: item.newMonth ? '1rem' : '0rem', backgroundColor: bgColors[item.month],
                                  color: item.total > 0 ? '#fff' : '#fff5',
                                }}>
                                {item.total}
                              </div>
                            ))}
                          </div>
                        </div>

                      </div>
                    </ScrollSyncPane>
                  </div>


                  <div className=" d-flex flex-row justify-content-start align-items-center py-2">
                    <div className="" style={{ width: 360 }}>
                      <Input
                        autoFocus
                        type="text"
                        placeholder="Search by asset name/code/location.."
                        style={{ width: '85%' }}
                        value={query}
                        onChange={(e) => { setQuery(e.target.value); }}
                      />
                    </div>
                    <div className="flex-1 ">
                      <div className="pb-0 d-flex flex-row flex-wrap justify-content-end align-items-center">
                        <div className="ps-5 py-0 d-flex flex-row justify-content-center align-items-center">
                          <div className="indicator me-2 calendar-completed" />
                          <div className="" style={{ color: '#9F9FA7' }}>Completed</div>
                        </div>
                        <div className="ps-5 py-0 d-flex flex-row justify-content-center align-items-center">
                          <div className="indicator me-2 calendar-delayed" />
                          <div className="" style={{ color: '#9F9FA7' }}>Delayed</div>
                        </div>
                        <div className="ps-5 py-0 d-flex flex-row justify-content-center align-items-center">
                          <div className="indicator me-2 calendar-cancelled" />
                          <div className="" style={{ color: '#9F9FA7' }}>Cancelled</div>
                        </div>
                        <div className="ps-5 py-0 d-flex flex-row justify-content-center align-items-center">
                          <div className="indicator me-2 calendar-missed" />
                          <div className="" style={{ color: '#9F9FA7' }}>Missed</div>
                        </div>
                        <div className="ps-5 py-0 d-flex flex-row justify-content-center align-items-center">
                          <div className="indicator me-2 calendar-pending" />
                          <div className="" style={{ color: '#9F9FA7' }}>Pending</div>
                        </div>
                      </div>
                    </div>
                  </div>




                  <div className="mt-0 flex-1 d-flex flex-row justify-content-start align-items-stretch" style={{}}>
                    {/* <div className="" style={{height: 50}}>
                          <Input autoFocus type="text" placeholder="Search by Asset name/code/location.." />
                        </div> */}
                    <ScrollSyncPane>
                      <div className="overflow-auto" style={{ width: 360, height: '41vh' }}>
                        {displayedAssets.map((dItem, dIdx) => (
                          <div key={dIdx} className="bg-white py-3 px-3 overflow-hidden d-flex flex-column justify-content-center align-items-start"
                            style={{ height: 100, marginBottom: '.1rem', }}>
                            <div className="calTaskAsset">{dItem.name || '-'}</div>
                            <div className="calTaskCode">{dItem.code || '-'}</div>
                            <div className="calTaskLocation">{dItem.location || '-'}
                            </div>
                          </div>
                        ))}
                      </div>
                    </ScrollSyncPane>
                    <ScrollSyncPane>
                      <div className="flex-1 overflow-auto" style={{ height: '41vh', width: 'calc(100% - 360px)' }}>
                        {loading ?
                          <div className="text-muted">Loading..</div> :
                          (displayedAssets.length < 1 ?
                            <div className="text-muted">No data</div> :
                            displayedAssets.map((dAsset, dAssetIdx) => (
                              <div
                                key={dAssetIdx}
                                className="d-flex flex-row justify-content-start align-items-stretch"
                                style={{ height: 100, marginBottom: '.1rem', }}
                              >
                                {dAsset.calendar.map((cCal, cCalIdx) => (
                                  <div
                                    key={cCalIdx}
                                    className="p-0"
                                  // style={{borderBottomColor: '#d2d2d7', borderBottomWidth: 1, borderBottomStyle: 'solid'}}
                                  >
                                    <div
                                      className="d-flex flex-column justify-content-center align-items-center tdiv-ppm"
                                      style={{
                                        marginRight: '0rem', marginLeft: data[cCalIdx]?.newMonth ? '1rem' : '0rem',
                                        backgroundColor: bg2Colors[parseInt(data[cCalIdx]?.month)],
                                      }}
                                    >
                                      {cCal.length < 1 ? '' :
                                        <div className="d-flex flex-row flex-wrap justify-content-center align-items-center">
                                          {cCal.map((cItm, cItmIdx) => (
                                            <div
                                              className="tooltipwrap1"
                                              key={cItmIdx}
                                              onClick={() => { setTaskId(cItm.id) }}
                                            >
                                              <div
                                                href="#"
                                                className={colorClasses[cItm.status]}
                                              ><span className="text-white">{cItm.ppmactivity.type == "Monthly" ? "M" : cItm.ppmactivity.type == "Weekly" ? "W" : cItm.ppmactivity.type == "Yearly" ? "Y" : cItm.ppmactivity.type == "Quarterly" ? "Q" : ""}</span></div>
                                              <div className="tooltip1 bg-white shadow shadow-sm px-4 py-2">
                                                <table className="table">
                                                  <tr className="mb-2">
                                                    <td className="pe-3 text-muted">Activity</td>
                                                    <td>{cItm.ppmactivity?.name}</td>
                                                  </tr>
                                                  <tr className="mb-2">
                                                    <td className="pe-3 text-muted">Frequency</td>
                                                    <td>{cItm.ppmactivity?.type}</td>
                                                  </tr>
                                                  <tr className="mb-2">
                                                    <td className="pe-3 text-muted">Scheduled</td>
                                                    <td>{cItm.start_date} - {cItm.end_date}</td>
                                                  </tr>
                                                  <tr className="mb-2">
                                                    <td className="pe-3 text-muted">Status</td>
                                                    <td>
                                                      <span style={{ color: cItm.status == 'completed' ? 'rgb(77, 163, 77)' : cItm.status == 'pending' ? 'rgb(217, 171, 88)' : cItm.status == 'missed' ? 'red' : '#222' }}>{cItm.status}</span>
                                                    </td>
                                                  </tr>
                                                </table>
                                                {/* <div className="d-flex flex-row align-items-center w100 border border-danger">
                                                  <div className="flex-1 border border-success pe-2" style={{color: '#888'}}>Activity</div>
                                                  <div className="flex-1 border border-success text-right">{cItm.ppmactivity_name}</div>
                                                </div>
                                                <div className="d-flex flex-row align-items-center w100 border border-danger">
                                                  <div className="flex-1 border border-success pe-2" style={{color: '#888'}}>Frequency</div>
                                                  <div className="flex-1 border border-success text-right">{cItm.ppmactivity_name}</div>
                                                </div> */}
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )))}
                      </div>
                    </ScrollSyncPane>
                  </div>




                </div>
              </CardBody>
            </Card>




          </Container>

          {taskId !== null &&
            <Task mode="ppm" id={taskId} setTaskId={setTaskId} />}

        </div>
      </React.Fragment>
    </ScrollSync>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(PpmCalendar)